import { Canvas } from '@react-three/fiber';
import SpaceBackground from './SpaceBackground';
import { space_image } from '../../../images';

const SpaceSwirlBackgroundWrapper = () => {
  return (
    <Canvas
      className="bgCanvas"
      orthographic
      camera={{ position: [0, 0, 1], zoom: 1 }}
    >
      <SpaceBackground url={space_image} />
    </Canvas>
  );
};

export default SpaceSwirlBackgroundWrapper;
